import { Card, Dropdown, Form, Header } from "semantic-ui-react";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import db from "astrid-firebase/src/db";
import cloudAgreementSkeleton from "astrid-firestore/src/api/agreements/constants/cloudAgreementSkeleton";
import earselectProducerId from "astrid-firestore/src/api/organizations/constants/earselectProducerId";
import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import AgreementsForm from "../../../agreements/components/AgreementsForm/AgreementsForm";

// Earselect is the only producer for now. Cloud agreements are signed outside Astrid and uploaded.
export default function SuperAdminCreateCloudAgreementView() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [producers = [], loadingProducers] = useCollectionData(
		useMemo(() => db.collection("organizations").where("type", "==", organizationTypes.PRODUCER), []),
	);

	const producer = producers.find(({ id }) => id === earselectProducerId);

	return (
		<>
			<Header as="h2">{t("newCloudAgreement", "New cloud agreement")}</Header>

			<Card fluid>
				<Card.Content>
					<Form>
						<Form.Field>
							<label>{t("producerFirstParty", "Producer (first party)")}</label>
							<Dropdown
								selection
								disabled
								id="cloudAgreementProducer"
								loading={loadingProducers}
								placeholder={t("selectProducer", "Select producer")}
								options={producers.map(({ id, name }) => ({ key: id, value: id, text: name }))}
								value={earselectProducerId}
							/>
						</Form.Field>
					</Form>
				</Card.Content>
			</Card>

			{producer && (
				<AgreementsForm
					organization={producer}
					defaults={cloudAgreementSkeleton}
					afterSubmit={() => navigate("/admin/finance/cloud-agreements")}
				/>
			)}
		</>
	);
}
